import { useMemo } from "react";
import { useProductCategories } from "./useProductCategories";

export function useCategoryLookup() {
  const { categories } = useProductCategories();

  return useMemo(
    () => new Map(categories.map((category) => [category.id, category])),
    [categories],
  );
}
